export default __webpack_public_path__ + "static/media/Group517.298188b6.png";